import * as React from "react";
import Menu from "./Menu";
import Header from "./Header";
import { RouteComponentProps } from "react-router";
import StatusBar from "../util/StatusBar";
import { Grid, LogoContainer, HeaderContainer, MenuContainer, ContentContainer, Logo, MessagesContainer } from "./Page.style";
export interface Props extends RouteComponentProps<any>
{
    
}

interface State
{
    
}

class Page extends React.Component<Props, State>
{
    render()
    {
        
        return (
            <Grid>
                <LogoContainer>
                    <Logo><span>HEY</span><span>PIM</span></Logo>
                </LogoContainer>
                <HeaderContainer>
                    <Header {...this.props}/>
                </HeaderContainer>
                <MessagesContainer>
                    <StatusBar />
                </MessagesContainer>
                <MenuContainer>
                    <Menu {...this.props} />
                </MenuContainer>
                <ContentContainer>
                    {this.props.children}
                </ContentContainer>
            </Grid>
        );
    }
}

export default Page;


// WEBPACK FOOTER //
// ./src/components/layout/Page.tsx